import { getIdOrNull } from '..'
import apiClient from './apiClient'

export const getAllInternshipRequestMetadata = (user, queryParams) => {
  return apiClient.get(user, 'api/internship-request-metadata', queryParams)
}

export const createInternshipRequestMetadata = (internshipRequestMetadata, user) => {
  return apiClient.post(user, 'api/internship-request-metadata', internshipRequestMetadata.toRequestBody())
}

export const updateInternshipRequestMetadata = (internshipRequestMetadata, user) => {
  return apiClient.patch(user, `api/internship-request-metadata/${getIdOrNull(internshipRequestMetadata)}`, internshipRequestMetadata.toRequestBody())
}

export const deleteInternshipRequestMetadata = (internshipRequestMetadata, user) => {
  return apiClient.delete(user, `api/internship-request-metadata/${getIdOrNull(internshipRequestMetadata)}`)
}

export const getMetadataByInstitution = institution => {
  return apiClient.get(null, `public/internship-request-metadata/${getIdOrNull(institution)}`)
}
